import styled from "styled-components";

import * as css from "styles/CssVariables.js";
import ButtonPrimary from "components/buttons/ButtonPrimary";

import bronzeCheckmarkIcon from "assets/img/icons/checkmark-bronze.svg";
import silverCheckmarkIcon from "assets/img/icons/checkmark-silver.svg";
import goldCheckmarkIcon from "assets/img/icons/checkmark-gold.svg";
import featureTickIcon from "assets/img/icons/icons8-feature-tick.svg";

const AdPlansSelection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;

  @media (max-width: 800px) {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
`;

const AdPlan = styled.div`
  width: 100%;
  max-width: 200px;
  padding: 20px 14px;
  box-sizing: border-box;

  background: ${css.FLAT_BOX_BACKGROUND};
  border-radius: ${css.BOX_RADIUS_SECONDARY};
  border: ${(props) => `1px solid ${props.color}`};

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${css.VERTICAL_BOX_MARGIN_MEDIUM};

  @media (max-width: 800px) {
    padding: 25px 25px;
    max-width: none;

    gap: ${css.VERTICAL_BOX_MARGIN_LARGE};
  }
`;

const AdPlanTopSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};

  @media (max-width: 800px) {
    gap: ${css.VERTICAL_BOX_MARGIN_MEDIUM};
  }
`;

const AdPlanHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;

  @media (max-width: 800px) {
    gap: 1px;
  }
`;

const AdPlanBadgeIcon = styled.div`
  width: 26px;
  min-width: 26px;

  transform: translateY(2px);

  @media (max-width: 800px) {
    width: 32px;
    min-width: 32px;
  }
`;

const AdPlanTitle = styled.div`
  font-size: 22px;
  font-weight: 600;

  @media (max-width: 800px) {
    font-size: 24px;
  }
`;

const AdPlanSubTitle = styled.div`
  font-size: 13px;
  color: ${css.TEXT_GREY};

  @media (max-width: 800px) {
    font-size: 14px;
  }
`;

const AdPlanPriceBox = styled.div`
  width: 100%;
  min-height: 72px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0px;
  justify-content: center;
`;

const AdPlanPrice = styled.div`
  font-size: 36px;

  @media (max-width: 800px) {
    font-size: 38px;
  }
`;

const AdPlanPriceInfo = styled.div`
  font-size: 13px;
  color: ${css.TEXT_GREY};
  line-height: 1;

  transform: translateY(4px);

  @media (max-width: 800px) {
    font-size: 14px;
  }
`;

const AdPlanPriceTerm = styled.div`
  font-size: 13px;
  color: ${css.TEXT_GREY};

  @media (max-width: 800px) {
    font-size: 14px;
  }
`;

const AdPlanFeatures = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
`;

const AdPlanFeaturesTitle = styled.div`
  font-size: 16px;
  font-weight: 500;

  @media (max-width: 800px) {
    font-size: 17px;
  }
`;

const AdPlanFeaturesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

const AdPlanFeature = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
`;

const AdPlanFeatureIcon = styled.div`
  width: 16px;
  min-width: 16px;

  transform: translateY(1px);

  @media (max-width: 800px) {
    width: 18px;
    min-width: 18px;

    transform: translateY(2px);
  }
`;

const AdPlanFeatureText = styled.div`
  font-size: 15px;

  white-space: nowrap;

  @media (max-width: 800px) {
    font-size: 16px;
  }
`;

const AdPlanFeatureBadgeIcon = styled.div`
  width: 18px;
  min-width: 18px;

  transform: translateY(2px);

  @media (max-width: 800px) {
    width: 20px;
    min-width: 20px;

    transform: translateY(3px);
  }
`;

const AdPlanBottomSection = styled.div``;

const AdPlanButtomWrap = styled.div`
  padding-top: 5px;
`;

export default ({ prices, onPlanSelect, activePlan }) => {
  let bronzePrice = 0;
  let silverPrice = 0;
  let goldPrice = 0;

  for (const price of prices) {
    if (price.product === "bronze_ad_plan") bronzePrice = price.price;
    if (price.product === "silver_ad_plan") silverPrice = price.price;
    if (price.product === "gold_20_ad_plan") goldPrice = price.price;
  }

  return (
    <AdPlansSelection>
      <AdPlan color="#D8A375">
        <AdPlanTopSection>
          <AdPlanHeader>
            <AdPlanBadgeIcon>
              <img src={bronzeCheckmarkIcon} style={{ width: "100%" }} />
            </AdPlanBadgeIcon>
            <AdPlanTitle>Bronze</AdPlanTitle>
            <AdPlanSubTitle>For aspiring entrepreneurs</AdPlanSubTitle>
          </AdPlanHeader>
          <AdPlanPriceBox>
            <AdPlanPrice>${bronzePrice / 100}</AdPlanPrice>
            <AdPlanPriceTerm>/month</AdPlanPriceTerm>
          </AdPlanPriceBox>
          <AdPlanFeatures>
            <AdPlanFeaturesTitle>Features</AdPlanFeaturesTitle>
            <AdPlanFeaturesList>
              <AdPlanFeature>
                <AdPlanFeatureIcon>
                  <img src={featureTickIcon} style={{ width: "100%" }} />
                </AdPlanFeatureIcon>
                <AdPlanFeatureText>2,500 Coins daily</AdPlanFeatureText>
              </AdPlanFeature>
              <AdPlanFeature>
                <AdPlanFeatureIcon>
                  <img src={featureTickIcon} style={{ width: "100%" }} />
                </AdPlanFeatureIcon>
                <AdPlanFeatureText>Bronze checkmark</AdPlanFeatureText>
                <AdPlanFeatureBadgeIcon>
                  <img src={bronzeCheckmarkIcon} style={{ width: "100%" }} />
                </AdPlanFeatureBadgeIcon>
              </AdPlanFeature>
              <AdPlanFeature>
                <AdPlanFeatureIcon>
                  <img src={featureTickIcon} style={{ width: "100%" }} />
                </AdPlanFeatureIcon>
                <AdPlanFeatureText>1 Telegram post per day</AdPlanFeatureText>
              </AdPlanFeature>
              <AdPlanFeature>
                <AdPlanFeatureIcon>
                  <img src={featureTickIcon} style={{ width: "100%" }} />
                </AdPlanFeatureIcon>
                <AdPlanFeatureText>Custom page redirect</AdPlanFeatureText>
              </AdPlanFeature>
            </AdPlanFeaturesList>
          </AdPlanFeatures>
        </AdPlanTopSection>
        <AdPlanBottomSection>
          <AdPlanButtomWrap>
            <ButtonPrimary
              onClick={() => onPlanSelect(1)}
              disabled={activePlan === 1}
            >
              {activePlan === 1 ? "Your Plan" : "Get Bronze"}
            </ButtonPrimary>
          </AdPlanButtomWrap>
        </AdPlanBottomSection>
      </AdPlan>
      <AdPlan color="#B6B7B8">
        <AdPlanTopSection>
          <AdPlanHeader>
            <AdPlanBadgeIcon>
              <img src={silverCheckmarkIcon} style={{ width: "100%" }} />
            </AdPlanBadgeIcon>
            <AdPlanTitle>Silver</AdPlanTitle>
            <AdPlanSubTitle>For experienced marketers</AdPlanSubTitle>
          </AdPlanHeader>
          <AdPlanPriceBox>
            <AdPlanPrice>${silverPrice / 100}</AdPlanPrice>
            <AdPlanPriceTerm>/month</AdPlanPriceTerm>
          </AdPlanPriceBox>
          <AdPlanFeatures>
            <AdPlanFeaturesTitle>Features</AdPlanFeaturesTitle>
            <AdPlanFeaturesList>
              <AdPlanFeature>
                <AdPlanFeatureIcon>
                  <img src={featureTickIcon} style={{ width: "100%" }} />
                </AdPlanFeatureIcon>
                <AdPlanFeatureText>10,000 Coins daily</AdPlanFeatureText>
              </AdPlanFeature>
              <AdPlanFeature>
                <AdPlanFeatureIcon>
                  <img src={featureTickIcon} style={{ width: "100%" }} />
                </AdPlanFeatureIcon>
                <AdPlanFeatureText>Silver checkmark</AdPlanFeatureText>
                <AdPlanFeatureBadgeIcon>
                  <img src={silverCheckmarkIcon} style={{ width: "100%" }} />
                </AdPlanFeatureBadgeIcon>
              </AdPlanFeature>
              <AdPlanFeature>
                <AdPlanFeatureIcon>
                  <img src={featureTickIcon} style={{ width: "100%" }} />
                </AdPlanFeatureIcon>
                <AdPlanFeatureText>2 Telegram posts per day</AdPlanFeatureText>
              </AdPlanFeature>
              <AdPlanFeature>
                <AdPlanFeatureIcon>
                  <img src={featureTickIcon} style={{ width: "100%" }} />
                </AdPlanFeatureIcon>
                <AdPlanFeatureText>Custom page redirect</AdPlanFeatureText>
              </AdPlanFeature>
              <AdPlanFeature>
                <AdPlanFeatureIcon>
                  <img src={featureTickIcon} style={{ width: "100%" }} />
                </AdPlanFeatureIcon>
                <AdPlanFeatureText>Video post</AdPlanFeatureText>
              </AdPlanFeature>
              <AdPlanFeature>
                <AdPlanFeatureIcon>
                  <img src={featureTickIcon} style={{ width: "100%" }} />
                </AdPlanFeatureIcon>
                <AdPlanFeatureText>6 chats/day</AdPlanFeatureText>
              </AdPlanFeature>
            </AdPlanFeaturesList>
          </AdPlanFeatures>
        </AdPlanTopSection>
        <AdPlanBottomSection>
          <AdPlanButtomWrap>
            <ButtonPrimary
              onClick={() => onPlanSelect(2)}
              disabled={activePlan === 2}
            >
              {activePlan === 2 ? "Your Plan" : "Get Silver"}
            </ButtonPrimary>
          </AdPlanButtomWrap>
        </AdPlanBottomSection>
      </AdPlan>
      <AdPlan color="#F0E326">
        <AdPlanTopSection>
          <AdPlanHeader>
            <AdPlanBadgeIcon>
              <img src={goldCheckmarkIcon} style={{ width: "100%" }} />
            </AdPlanBadgeIcon>
            <AdPlanTitle>Gold</AdPlanTitle>
            <AdPlanSubTitle>For serious businesses</AdPlanSubTitle>
          </AdPlanHeader>
          <AdPlanPriceBox>
            <AdPlanPriceInfo>from</AdPlanPriceInfo>
            <AdPlanPrice>${goldPrice / 100}</AdPlanPrice>
            <AdPlanPriceTerm>/month</AdPlanPriceTerm>
          </AdPlanPriceBox>
          <AdPlanFeatures>
            <AdPlanFeaturesTitle>Features</AdPlanFeaturesTitle>
            <AdPlanFeaturesList>
              <AdPlanFeature>
                <AdPlanFeatureIcon>
                  <img src={featureTickIcon} style={{ width: "100%" }} />
                </AdPlanFeatureIcon>
                <AdPlanFeatureText>20,000+ Coins daily</AdPlanFeatureText>
              </AdPlanFeature>
              <AdPlanFeature>
                <AdPlanFeatureIcon>
                  <img src={featureTickIcon} style={{ width: "100%" }} />
                </AdPlanFeatureIcon>
                <AdPlanFeatureText>Gold checkmark</AdPlanFeatureText>
                <AdPlanFeatureBadgeIcon>
                  <img src={goldCheckmarkIcon} style={{ width: "100%" }} />
                </AdPlanFeatureBadgeIcon>
              </AdPlanFeature>
              <AdPlanFeature>
                <AdPlanFeatureIcon>
                  <img src={featureTickIcon} style={{ width: "100%" }} />
                </AdPlanFeatureIcon>
                <AdPlanFeatureText>3 Telegram posts per day</AdPlanFeatureText>
              </AdPlanFeature>
              <AdPlanFeature>
                <AdPlanFeatureIcon>
                  <img src={featureTickIcon} style={{ width: "100%" }} />
                </AdPlanFeatureIcon>
                <AdPlanFeatureText>Custom page redirect</AdPlanFeatureText>
              </AdPlanFeature>
              <AdPlanFeature>
                <AdPlanFeatureIcon>
                  <img src={featureTickIcon} style={{ width: "100%" }} />
                </AdPlanFeatureIcon>
                <AdPlanFeatureText>Video post</AdPlanFeatureText>
              </AdPlanFeature>
              <AdPlanFeature>
                <AdPlanFeatureIcon>
                  <img src={featureTickIcon} style={{ width: "100%" }} />
                </AdPlanFeatureIcon>
                <AdPlanFeatureText>10 chats/day</AdPlanFeatureText>
              </AdPlanFeature>
              <AdPlanFeature>
                <AdPlanFeatureIcon>
                  <img src={featureTickIcon} style={{ width: "100%" }} />
                </AdPlanFeatureIcon>
                <AdPlanFeatureText>Extended post</AdPlanFeatureText>
              </AdPlanFeature>
              <AdPlanFeature>
                <AdPlanFeatureIcon>
                  <img src={featureTickIcon} style={{ width: "100%" }} />
                </AdPlanFeatureIcon>
                <AdPlanFeatureText>Highlighted post</AdPlanFeatureText>
              </AdPlanFeature>
              <AdPlanFeature>
                <AdPlanFeatureIcon>
                  <img src={featureTickIcon} style={{ width: "100%" }} />
                </AdPlanFeatureIcon>
                <AdPlanFeatureText>Sponsored message</AdPlanFeatureText>
              </AdPlanFeature>
            </AdPlanFeaturesList>
          </AdPlanFeatures>
        </AdPlanTopSection>
        <AdPlanBottomSection>
          <AdPlanButtomWrap>
            <ButtonPrimary onClick={() => onPlanSelect(3)}>
              {activePlan >= 3 ? "Adjust Plan" : "Get Gold"}
            </ButtonPrimary>
          </AdPlanButtomWrap>
        </AdPlanBottomSection>
      </AdPlan>
    </AdPlansSelection>
  );
};
